import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { closeH2HModal } from "../../redux/matchesSlice";
import { useDispatch, useSelector } from "react-redux";

const Stats1Modal = React.memo((props) => {
    const { matchId, homeTeam, awayTeam } = props;

    const dispatch = useDispatch();
    const { show_h2h_modal} = useSelector(state => state.matchesData);

    const handleClose = () => {
      // console.log("show_h2h_modal", show_h2h_modal);
      dispatch(closeH2HModal());
      const appElement = document.getElementById('app');
      if(!show_h2h_modal) {
        appElement.classList.add('dim');
      }
      else {
        appElement.classList.remove('dim');
      }
    };

    useEffect(() => {
        window.SIR("addWidget", "#sr-widget", "headToHead.standalone", {
          // position: "bottom",
          components: ["headtohead", "form", "teamstats", "lastmatches"],
          // label: "Stats",
          layout: "overlay",
          matchId: matchId,
        });
    }, [matchId]);

  return (
    <Modal
      // show={isOpen}
      show={show_h2h_modal}
      className={"shadow-lg filters-modal1"}
      dialogClassName={"modal-30w"}
      centered={true}
      size={"md"}
      backdrop={"static"}
      style={{ zIndex: "9999" }}
    >
      <Modal.Header closeButton={false} className={"w-100"} style={{ border: "none" }}>
        <Modal.Title className={"w-100"}>
          <div
            className={
              "d-flex justify-content-start align-items-centre flex-row px-4"
            }
          >
            <div style={{ width: "100%", textAlign: "center" }}>
                <strong className={""} style={{ width: "90%" }}>
                    {homeTeam} vs {awayTeam}
                </strong>
            </div>
            <div className="close-history-filter1 deposit-modal">
                <input
                  id={"deposit"}
                  type="submit"
                  value="X"
                  onClick={handleClose}
                />
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="stats-modal-body">
        <div id={`sr-widget`}></div>
      </Modal.Body>
    </Modal>
  );
});
export default Stats1Modal;
